import { Children, useEffect, useRef, useState } from "react";
import { cloneElement } from "react";
import toast from "react-hot-toast";
import { Navigate, Route } from "react-router-dom";
import platform from "platform";
import axios from "../axios";
import NotFound from "../component/NotFound";
// const importAll = (r) => {
//   let images = {};
//   r.keys().map((item) => {
//     return (images[item.replace("./", "")] = r(item));
//   });
//   return images;
// };

// const images = importAll(require.context("../asset/images", false));

const importAll = (modules) => {
  let images = {};
  for (const path in modules) {
    // const imageName = path.replace('../asset/images/', '').replace(/\.\w+$/, '');
    const imageName = path.replace("../asset/images/", ""); // Keep the file extension

    images[imageName] = modules[path].default; // Access the default export
  }
  return images;
};

const images = importAll(
  import.meta.glob("../asset/images/*", { eager: true }),
);

const checkLogin = () => {
  var status = false;
  if (localStorage.getItem("MetBrains_token") != null) {
    status = true;
  }
  return status;
};

const notifySuccess = (notification) => toast.success(notification);

// To update this function to show modal in case the session has expired and the server has returned 401
const notifyDanger = (notification) =>
  !localStorage.getItem("session_expired") && toast.error(notification);

import { Suspense } from "react";
import Loader, { VideoLoader } from "../component/Loader";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../component/ErrorFallback";

function wrapWithSuspense(page, path) {
  if (path === "/") {
    return (
      <Suspense fallback={null}>
        <HomeGate>{page}</HomeGate>
      </Suspense>
    );
  }

  return <Suspense fallback={<Loader />}>{page}</Suspense>;
}

function HomeGate({ children }) {
  const [showVideo, setShowVideo] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowVideo(false), 2500); // 5 sec
    return () => clearTimeout(timer);
  }, []);

  if (showVideo) {
    return <VideoLoader />;
  }

  return children;
}

const GetRoutes = (allRoutes) => {
  let final = allRoutes.map((route) => {
    if (route.path) {
      return (
        <Route
          exact
          path={route.path}
          element={
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              {route.private === true ? (
                checkLogin() === true ? (
                  wrapWithSuspense(route.page, route.path)
                ) : (
                  <Navigate to="/" />
                )
              ) : (
                wrapWithSuspense(route.page, route.path)
              )}
            </ErrorBoundary>
          }
          key={route.key}
        >
          {route?.children && GetRoutes(route.children)}
        </Route>
      );
    }
    if (route.index) {
      return (
        <Route
          key={route.key}
          index
          element={wrapWithSuspense(route.page, route.path)}
        />
      );
    }
    return null;
  });

  final.push(<Route path="*" element={<NotFound />} />);
  return final;
};

const confirmToast = (text, func) => {
  toast(
    (t) => (
      <div className="custom-toast">
        <h5>{text}</h5>
        <div className="d-flex justify-content-end" style={{ gap: "10px " }}>
          <button
            className="btn btn-success"
            onClick={() => {
              func();
              toast.dismiss(t.id);
            }}
          >
            OK
          </button>
          {/* <button className="btn btn-danger" onClick={() => toast.dismiss(t.id)}>
            No
          </button> */}
        </div>
      </div>
    ),
    { duration: 100000 },
  );
};

const toastConfirm = (text, func) => {
  toast(
    (t) => (
      <div className="custom-toast">
        <h5>{text}</h5>
        <div className="d-flex justify-content-end" style={{ gap: "10px " }}>
          <button
            className="btn btn-success"
            onClick={() => {
              func();
              toast.dismiss(t.id);
            }}
          >
            Yes
          </button>
          <button
            className="btn btn-danger"
            onClick={() => toast.dismiss(t.id)}
          >
            No
          </button>
        </div>
      </div>
    ),
    // { duration: 100000 }
  );
};

function updateMetaTagContent(ID, newContent) {
  var metaTag = document.getElementById(ID);
  if (metaTag) {
    metaTag.setAttribute("content", newContent);
  }
}

function updateTitle(ID, newContent) {
  var titleTag = document.getElementById(ID);
  if (titleTag) {
    titleTag.textContent = newContent;
  }
}

const addLazyLoadingAttribute = (element) => {
  if (!element) {
    return element;
  }

  // If the element has a type of 'img', add the loading="lazy" attribute
  if (element.type === "img") {
    const updatedElement = cloneElement(element, { loading: "lazy" });
    return updatedElement;
  }

  // If it's a regular element with children, recursively process its children
  if (element.props && element.props.children) {
    const updatedChildren = Children.map(element.props.children, (child) =>
      addLazyLoadingAttribute(child),
    );
    return cloneElement(element, {}, updatedChildren);
  }

  return element;
};

// Function to wrap your JSX with lazy loading attribute
const LazyLoadingWrapper = ({ children }) => {
  const lazyLoadedChildren = Children.map(children, (child) =>
    addLazyLoadingAttribute(child),
  );

  return <>{lazyLoadedChildren}</>;
};

const FadeInWrapper = ({ children }) => {
  return (
    <div
      className="fade-in-wr"
      data-aos="fade-in"
      data-aos-duration="200"
      data-aos-easing="ease-in-out"
    >
      {children}
    </div>
  );
};

function getCategoryFromCourseTitle(title) {
  if (!title) return null;
  else if (
    title.toLowerCase() === "DEVX - DevOps Excellence Program".toLowerCase()
  ) {
    return "DevOps Engineering";
  } else if (
    title.toLowerCase() ===
    "MIND - Mentorship in AI & Data Science".toLowerCase()
  ) {
    return "Data Science";
  } else if (title.toLowerCase() === "Project Management".toLowerCase()) {
    return "Project Management";
  } else if (
    title.toLowerCase() ===
    "DEAP - Data Engineering Applied Program".toLowerCase()
  ) {
    return "Data Engineering";
  } else if (
    title.toLowerCase() ===
    "DATAX - Data Analytics Training & Applied experience".toLowerCase()
  ) {
    return "Data Analytics";
  } else if (title.toLowerCase() === "Digital Marketing".toLowerCase()) {
    return "Digital Marketing";
  } else if (
    title.toLowerCase() ===
    "CAMP - Cyber Security Applied Mentorship".toLowerCase()
  ) {
    return "Cyber Security";
  } else if (
    title.toLowerCase() ===
    "CBA - Certified Business Analytics Program".toLowerCase()
  ) {
    return "Business Analytics";
  }
}

const ExpandableText = ({ text, limit }) => {
  const [state, setState] = useState(false);
  return (
    <>
      {state ? text : text.slice(0, limit ? limit : 200) + "..."}
      {state ? (
        <button
          onClick={() => {
            setState((prev) => !prev);
          }}
          style={{
            border: "none",
            outline: "none",
            color: "#000",
            background: "transparent",
            fontWeight: "600",
          }}
        >
          Read less
        </button>
      ) : (
        <button
          onClick={() => {
            setState((prev) => !prev);
          }}
          style={{
            border: "none",
            outline: "none",
            color: "#000",
            background: "transparent",
            fontWeight: "600",
          }}
        >
          Read more
        </button>
      )}{" "}
    </>
  );
};

const handleTourClose = async (tourType) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("MetBrains_token")}`,
      },
    };
    const res = await axios.post(
      "/user/close-tour",
      {
        tourType,
      },
      config,
    );
    if (res.status === 200) {
    }
  } catch (error) {
    console.log(error);
  }
};

const FadeLeftWrapper = ({ children }) => {
  return (
    // <ReactVisibilitySensor onChange={onChange} partialVisibility={true}>
    // <>
    //   {({ isVisible }) => (
    //     <motion.div
    //       initial={{ opacity: 0, x: -200 }} // Initial state (invisible)
    //       animate={isVisible ? { opacity: 1, x: 0 } : {}}
    //       transition={{ duration: 1 }} // Animation duration in seconds
    //     >
    //       {children}
    //     </motion.div>
    //   )}
    // </>

    <div
      data-aos="fade-left"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
    >
      {children}
    </div>

    // </ReactVisibilitySensor>
  );
};

const FadeRightWrapper = ({ children }) => {
  return (
    <div
      data-aos="fade-right"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
    >
      {children}
    </div>
  );
};

const FadeOutWrapper = ({ children }) => {
  return (
    <div
      data-aos="fade"
      data-aos-anchor-placement="top-bottom"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
    >
      {children}
    </div>
  );
};

const RazorPayBtn = (
  isAccept,
  setIsLoading,
  dataMain,
  amountInUsd,
  afterPayment,
  razorpayConfirm,
  customNote,
) => {
  setIsLoading(true);
  if (isAccept) {
    dataMain.amount = amountInUsd.amount;
    dataMain.currency = amountInUsd.currency;
  }

  let notesObj = {
    contact: dataMain.contact || "",
    name: dataMain.name || "User",
    email: dataMain.email,
    address: dataMain.address || "Remote ATS User",
    country: dataMain.country,
    gender: dataMain.gender || "",
  };

  if (customNote) notesObj = { ...notesObj, ...customNote };

  axios
    .post("/payment/create", dataMain)
    .then((res) => {
      setIsLoading(false);
      const { data } = res;

      const notes = JSON.stringify(notesObj);

      const options = {
        key: data.key_id,
        amount: data.amount,
        currency: data.currency,
        order_id: data.order_id,
        handler: async function (response) {
          afterPayment(data, dataMain, response);
        },
        prefill: {
          contact: data.contact,
          name: data.name,
          email: data.email,
          address: data.address,
          country: data.country,
          gender: data.gender,
        },
        description: notes,
        notes: notes,
        theme: {
          color: "#024c87",
        },
      };
      const razorpayObject = new window.Razorpay(options);
      razorpayObject.on("payment.failed", function () {
        notifyDanger("Payment Failed");
      });
      razorpayObject.open();
    })
    .catch((err) => {
      console.log("rzp err", err);
      if (razorpayConfirm !== null) {
        confirmToast(
          "Your currency is not supported please pay in Dollars",
          razorpayConfirm,
        );
      }
      setIsLoading(false);
    });
};

const createPaypalButton = (
  amount,
  amountInUsd,
  userInfo,
  isPaypalFail,
  paypalConfirm,
  afterPayment,
  productType,
) => {
  let IncreaseAmount = Math.floor(amount + amount * (2.5 / 100));
  if (isPaypalFail) {
    IncreaseAmount = Math.floor(
      amountInUsd.amount + amountInUsd.amount * (2.5 / 100),
    );
  }

  const purchaseUnitObj =
    productType === "masterclass"
      ? {
          amount: {
            currency_code: isPaypalFail
              ? amountInUsd.currency
              : userInfo.currency,
            value: IncreaseAmount,
          },
          custom_id: "masterclass",
        }
      : {
          amount: {
            currency_code: isPaypalFail
              ? amountInUsd.currency
              : userInfo.currency,
            value: IncreaseAmount,
          },
        };

  window.paypal
    .Buttons({
      createOrder: function (data, actions) {
        return actions.order.create({
          purchase_units: [purchaseUnitObj],
        });
      },
      onApprove: function (data, actions) {
        return actions.order.capture().then(function () {
          afterPayment();
        });
      },
      onError: function (err) {
        console.log("paypal err 3", err);
        confirmToast(
          "Your currency is not supported click again on paypal button to pay in dollars",
          paypalConfirm,
        );
      },
    })
    .render("#paypal-button-container");
};

const loadScriptTag = (callback, currency) => {
  var scriptTag = document.createElement("script");
  scriptTag.src = `https://www.paypal.com/sdk/js?client-id=AepIC_tb-Z7AebO9PDgcTAZ_1vrodDRJmPe1HfcGncOMaZP3lJE2oOQhsCnrTIYxslemZLbAVlAVwTKV&currency=${currency}`;
  scriptTag.async = true;
  scriptTag.onload = callback;
  document.body.appendChild(scriptTag);
};

const handleScrollTo = (ID) => {
  const element = document.getElementById(ID);
  element.scrollIntoView({ behavior: "smooth" });
};

const handleScrollToError = (className) => {
  const element = document.querySelector(`.${className}`);
  if (element) {
    element?.previousElementSibling.scrollIntoView({ behavior: "smooth" });
  }
};

function useOutsideClick(ref, setIsOpen) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref && ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

function useOutsideClickHeader(ref, func) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref && ref.current && !ref.current.contains(event.target)) {
        func();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const getFileExtension = (filename) => {
  const parts = filename.split(".");
  return parts[parts.length - 1].toLowerCase();
};

export default function getPlatformInfo() {
  const deviceInfo = {
    os: platform.os.family,
    osVersion: platform.os.version,
    browser: platform.name,
    browserVersion: platform.version,
    device: platform.product ? platform.product.name : "Unknown Device",
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    language: navigator.language,
    userAgent: navigator.userAgent,
  };
  return deviceInfo;
}

const checkType = (type) => {
  if (
    type === "png" ||
    type === "jpeg" ||
    type === "gif" ||
    type === "pdf" ||
    type === "csv" ||
    type === "xlsx" ||
    type === "docx"
  ) {
    return true;
  } else {
    return false;
  }
};

const IconsImgObj = {
  doc: images["docsicon.png"],
  docx: images["docsicon.png"],
  gsheet: images["gsheeticon.png"],
  xl: images["excelicon.png"],
  xls: images["excelicon.png"],
  xlsx: images["excelicon.png"],
  py: images["pyfile.png"],
  ipynb: images["ipynbfile.png"],
  json: images["jsonfile.png"],
  jpg: images["jpgIcon.png"],
  jpeg: images["jpegfile.png"],
  png: images["pngfile.png"],
  gif: images["giffile.png"],
  txt: images["txticon.png"],
  odt: images["odticon.png"],
  rtf: images["rtficon.png"],
  csv: images["csvicon.png"],
  cvs: images["cvsicon.png"],
  pdf: images["pdfIcon.png"],
};

const useInViewport = (options = {}) => {
  const [inView, setInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setInView(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [options]);

  return [ref, inView];
};

function truncateString(str, maxLength) {
  return str.length > maxLength ? str.slice(0, maxLength) + "..." : str;
}

export {
  truncateString,
  IconsImgObj,
  useInViewport,
  handleScrollToError,
  checkType,
  GetRoutes,
  images,
  notifySuccess,
  notifyDanger,
  updateMetaTagContent,
  updateTitle,
  confirmToast,
  LazyLoadingWrapper,
  FadeInWrapper,
  FadeLeftWrapper,
  FadeRightWrapper,
  FadeOutWrapper,
  RazorPayBtn,
  createPaypalButton,
  loadScriptTag,
  handleScrollTo,
  toastConfirm,
  useOutsideClick,
  getFileExtension,
  useOutsideClickHeader,
  handleTourClose,
  ExpandableText,
  getCategoryFromCourseTitle,
};
